const AllProductData = (productData) => {
  const finalProductData = {
    imageInfo: {},
    rightTextInfo: {},
  };

  const productDataTemp = productData;

  Object.keys(productDataTemp).forEach((item) => {
    if (
      item.indexOf('productImageMark') !== -1
      || item.indexOf('images') !== -1
      || item.indexOf('youtubeUrl') !== -1
      || item.indexOf('youtubeKey') !== -1
      || item.indexOf('vrUrl') !== -1
    ) {
      finalProductData.imageInfo[item] = productDataTemp[item];
      delete productDataTemp.item;
    } else if (
      item.indexOf('name') !== -1
      || item.indexOf('sku') !== -1
      || item.indexOf('shortDesc') !== -1
      || item.indexOf('star') !== -1
      || item.indexOf('totalReview') !== -1
      || item.indexOf('brandName') !== -1
      || item.indexOf('brandUrl') !== -1
      || item.indexOf('firstPriceName') !== -1
      || item.indexOf('firstPrice') !== -1
      || item.indexOf('secondPriceName') !== -1
      || item.indexOf('secondPrice') !== -1
      || item.indexOf('pointName') !== -1
      || item.indexOf('pointPrice') !== -1
      || item.indexOf('backPoint') !== -1
      || item.indexOf('backPointName') !== -1
      || item.indexOf('backPointUrl') !== -1
      || item.indexOf('stockLevel') !== -1
      || item.indexOf('isTracking') !== -1
      || item.indexOf('isNotice') !== -1
      || item.indexOf('apiStockNote') !== -1
      || item.indexOf('deliveryCostUrl') !== -1
      || item.indexOf('deliveryModeUrl') !== -1
      || item.indexOf('hasCoupon') !== -1
      || item.indexOf('introduction') !== -1
    ) {
      if (item === 'isTracking') {
        productDataTemp.isTracking = productDataTemp.isTracking !== 'N';
      }
      if (item === 'isNotice') {
        productDataTemp.isNotice = productDataTemp.isNotice !== 'N';
      }
      // 右側靜態資訊
      finalProductData.rightTextInfo[item] = productDataTemp[item];
      delete productDataTemp.item;
    } else {
      finalProductData[item] = productDataTemp[item];
    }
  });

  return finalProductData;
};

export const finalProductData = AllProductData(window.productData || {});

export const finalPrdPageBrandStyle = window.prdPageBrandStyle || null;
